import { resolveSemanticColor } from '@/theme/semanticTokens';
import type { Theme } from '@/ui/primitives';

export const chartPanelSurfaceBackgroundColor = 'var(--surface-card)' as const;

export const resolveChartPanelSurfaceBackgroundColor = (theme: Theme): string =>
  resolveSemanticColor(theme, 'surface');

export const resolveChartPanelSurfaceBackgroundColorImportant = (theme: Theme): string =>
  `${resolveChartPanelSurfaceBackgroundColor(theme)} !important`;

export const buildPopoverFocusAreaMaskShadow = (spreadPx: number, color: string): string =>
  `0 0 0 ${String(spreadPx)}px ${color}`;
